import ApiService from './apiServices';
import { APIEndpoints } from './constants';

export const Api = {
  login: async values => {
    const response = await ApiService.post(APIEndpoints.login, values);
    console.log('Login response:', response.data);
    return response;
  },

  register: async values => {
    const payload = {
      name: values?.name,
      email: values?.email,
      password: values?.password,
    };
    const response = await ApiService.post(APIEndpoints.register, payload);
    return response;
  },

  forgotPassword: async email => {
    return await ApiService.post(APIEndpoints.forgotPassword, email);
  },

  resetPassword: async (token, password) => {
    return await ApiService.post(APIEndpoints.resetPassword, {
      token,
      new_password: password,
    });
  },





  /****************** User Management APIs ******************/

  getUsers: async () => {
    return await ApiService.get(APIEndpoints.getUsers);
  },

  getSubjects: async () => {
    return await ApiService.get(APIEndpoints.getSubjects);
  },

  getAllModelAnswers: async () => {
    return await ApiService.get(APIEndpoints.getAllModelAnswers);
  },

  createUser: async (payload) => {
    return await ApiService.post(APIEndpoints.createUser, payload);
  },

  blockedUser: async (id) => {
    return await ApiService.post(APIEndpoints.blockedUser(id));
  },

  unblockedUser: async (id) => {
    return await ApiService.post(APIEndpoints.unblockedUser(id));
  },






  /****************** modal-answer upload api ******************/
  uploadAnswer: async (payload) => {
    return await ApiService.post(APIEndpoints.uploadAnswer, payload);
  },

  getModalAnswer: async () => {
    return await ApiService.get(APIEndpoints.getModalAnswer);
  },





  /****************** past-modal-answer upload api ******************/
  uploadPastModelAnswer: async (payload) => {
    return await ApiService.post(APIEndpoints.uploadPastModelAnswer, payload);
  },

  getPastModelAnswers: async () => {
    return await ApiService.get(APIEndpoints.getPastModelAnswers);
  },





  /****************** Submissions APIs ******************/
  getSubmissions: async () => {
    return await ApiService.get(APIEndpoints.getSubmissions);
  },

  getSubmissionDetails: async (id) => {
    return await ApiService.get(`${APIEndpoints.getSubmissionDetails}/${id}`);
  },

  updateStatus: async (submissionId, payload) => {
    return await ApiService.put(APIEndpoints.updateStatus(submissionId), payload);
  },


  getResultDetails: async (id) => {
    return await ApiService.get(APIEndpoints.getResultDetails(id));
  },







  /****************** Flagged content APIs ******************/
  getFlag: async () => {
    return await ApiService.get(APIEndpoints.getFlag);
  },

  addFlag: async (submissionId) => {
    return await ApiService.post(APIEndpoints.addFlag(submissionId));
  },
  removeFlag: async (submissionId) => {
    return await ApiService.post(APIEndpoints.removeFlag(submissionId));
  },





  /****************** Profile APIs ******************/
  getProfile: async () => {
    return await ApiService.get(APIEndpoints.getProfile);
  },

  updateProfile: async (id, payload) => {
    return await ApiService.put(APIEndpoints.updateProfile(id), payload);
  },




  /****************** AI Results APIs ******************/
  updateAIResult: async (id, payload) => {
    return await ApiService.put(APIEndpoints.updateAIResult(id), payload);
  },


  /****************** Past Modal Answer APIs ******************/
  getPastModalAnswer: async () => {
    return await ApiService.get(APIEndpoints.getPastModalAnswer);
  },

  uploadPastModalAnswer: async (payload) => {
    return await ApiService.post(APIEndpoints.uploadPastModalAnswer, payload);
  },

  deletePastModalAnswer: async (id) => {
    return await ApiService.delete(APIEndpoints.deletePastModalAnswer(id));
  },



  /****************** Subscription APIs ******************/
  getPurchases: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.status) queryParams.append('status', params.status);
    if (params.user_id) queryParams.append('user_id', params.user_id);
    const queryString = queryParams.toString();
    const url = queryString ? `${APIEndpoints.getPurchases}?${queryString}` : APIEndpoints.getPurchases;
    return await ApiService.get(url);
  },






  /****************** Subscriptions APIs ******************/
  getPlans: async () => {
    return await ApiService.get(APIEndpoints.getPlans);
  },

  createPlan: async (payload) => {
    return await ApiService.post(APIEndpoints.createPlan, payload);
  },

  updatePlan: async (id, payload) => {
    return await ApiService.put(APIEndpoints.updatePlan(id), payload);
  },

  deletePlan: async (id) => {
    return await ApiService.delete(APIEndpoints.deletePlan(id));
  },

};